module.exports = __webpack_public_path__ + "img/IMG_8998.3952a9ac.jpg";